import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useSeo } from "@/hooks/useSeo";
import Header from "@/components/public/Header";
import Footer from "@/components/public/Footer";
import AboutSections from "@/components/public/AboutSections";
import { useLead } from "@/components/public/LeadDialog";

export default function AboutUs() {
  useSeo("/about-us");
  const { openLead } = useLead();
  const [content, setContent] = useState(null);
  const [settings, setSettings] = useState({});

  useEffect(() => {
    api.get("/public/about").then((r) => setContent(r.data)).catch(() => setContent(null));
    api.get("/public/homepage").then((r) => setSettings(r.data.settings)).catch(() => {});
  }, []);

  if (!content) {
    return <div className="min-h-screen flex items-center justify-center"><div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin" /></div>;
  }

  return (
    <div className="bg-white min-h-screen" data-testid="about-us-page">
      <Header phone={settings.phone} />
      <AboutSections data={content} openLead={openLead} />
      <Footer settings={settings} />
    </div>
  );
}
